<template>
  <div @mousemove="handTime">
    <router-view v-if="this.$store.getters.siteInfo" />
  </div>
</template>

<script>
import APIUtil from "./util/APIUtil";
export default {
  name: "App",
  data() {
    return {
      // 最后一次点击时间
      lastTime: null,
      // 15分钟
      timeOver: 900000
    };
  },
  created() {
    // 站点信息取得
    this.searchSiteInfo();
    //初始话 重新计算时间
    this.lastTime = new Date().getTime();
    // 窗体大小变更
    let me = this;
    window.onresize = function() {
      me.onWindowResize();
    };
    me.onWindowResize();
  },
  watch: {
    // 站点切换
    "$route.params.site_id": "searchSiteInfo"
  },
  computed: {
    themInfo() {
      return this.$store.getters.getThemStatus;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setThem();
    });
  },
  methods: {
    handTime() {
      this.lastTime = new Date().getTime();
    },
    setThem() {
      let bodyStyle = document.getElementsByTagName("body")[0].style;
      if (this.themInfo && this.themInfo.id) {
        bodyStyle.setProperty("--menuDegree", this.themInfo.menuDegree + "deg");
        bodyStyle.setProperty("--menuFonColor", this.themInfo.menuFonColor);
        bodyStyle.setProperty(
          "--menuBackgroundOne",
          this.themInfo.menuBackgroundOne
        );
        bodyStyle.setProperty(
          "--menuBackgroundTow",
          this.themInfo.menuBackgroundTow
        );
        bodyStyle.setProperty(
          "--secondMenuBackground",
          this.themInfo.secondMenuBackground
        );
        bodyStyle.setProperty("--menuItemHover", this.themInfo.menuItemHover);
        bodyStyle.setProperty("--menuItemActive", this.themInfo.menuItemActive);
        bodyStyle.setProperty(
          "--secondMenuItemOne",
          this.themInfo.secondMenuItemOne
        );
        bodyStyle.setProperty("--themColor", this.themInfo.themColor);
      }
    },
    // 站点信息取得
    searchSiteInfo() {
      // 清除原站点信息
      this.$store.commit("siteInfo", null);

      // 取得站点信息
      APIUtil.findSiteInfo(this);
    },

    // 响应式类型设定
    onWindowResize: function() {
      if (window.document.body.clientWidth >= 1600) {
        this.$store.commit("responsiveMode", "xxl");
      } else if (window.document.body.clientWidth >= 1200) {
        this.$store.commit("responsiveMode", "xl");
      } else if (window.document.body.clientWidth >= 992) {
        this.$store.commit("responsiveMode", "lg");
      } else if (window.document.body.clientWidth >= 768) {
        this.$store.commit("responsiveMode", "md");
      } else if (window.document.body.clientWidth >= 576) {
        this.$store.commit("responsiveMode", "sm");
      } else {
        this.$store.commit("responsiveMode", "xs");
      }
    }
  }
};
</script>

<style lang="scss">
html {
  zoom: 80%;
}
@import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
@import "../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
@import "./assets/css/common1.scss";
.box-margin {
  margin-bottom: 20px;
}
.ivu-form-item-label {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #000 !important;
}

.ivu-layout-header {
  // background: url(./assets/img.jpg) no-repeat;
  background-color: #006b37 !important;
  background-size: 100% 64px !important;
}
.ivu-input[disabled],
fieldset[disabled] .ivu-input {
  color: #515a6e !important;
}
.ivu-checkbox-disabled.ivu-checkbox-checked .ivu-checkbox-inner:after {
  border-color: #515a6e !important;
}
.ivu-select-disabled .ivu-select-selection {
  color: #515a6e !important;
}
.applyBtnRight {
  margin-right: 20px !important;
}
.btnRight {
  margin-top: -5px !important;
  margin-bottom: 0px !important;
  display: flex !important;
  justify-content: center !important;
  width: 100% !important;
}
.ivu-btn-primary {
  color: white !important;
  background: var(--themColor) !important;
}
.ivu-btn-default {
  color: white !important;
  background: var(--themColor) !important;
}
.ivu-btn-text {
  color: white !important;
  background: var(--themColor) !important;
}
.ivu-btn-default:hover {
  color: #2b85e4 !important;
  background: none !important;
  border: 1px solid #2b85e4 !important;
}
.ivu-btn-text:hover {
  color: #2b85e4 !important;
  background: none !important;
  border: 1px solid #2b85e4 !important;
}
.ivu-btn[disabled] {
  color: white !important;
  background: #c5c8ce !important;
  border: #c5c8ce !important;
}
.ivu-btn[disabled]:hover {
  color: white !important;
  background: #c5c8ce !important;
  border: #c5c8ce !important;
}
.ivu-btn-primary:hover {
  color: #2b85e4 !important;
  background: none !important;
  border: 1px solid #2b85e4 !important;
}
.ivu-input-search:hover {
  color: white !important;
  background: var(--themColor) !important;
}
.ivu-input-search:active {
  color: white !important;
  background: var(--themColor) !important;
}
.ivu-spin-fix {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 8;
  width: 101% !important;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.9);
}
.textareaHid {
  text-align: left;
  float: left;
  white-space: break-spaces;
}
</style>



// WEBPACK FOOTER //
// src/App.vue